import { NgModule } from '@angular/core';
import { AutocompleteOffDirective } from './disable-autocomplete.directive';

@NgModule({
  declarations: [AutocompleteOffDirective],
  exports: [AutocompleteOffDirective],
})
export class DisableAutocompleteDirectiveModule {}
